export enum PicoRoleEnum {
  USER = "user",
  ADMIN = "admin",
}
